import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import 'devextreme/data/odata/store';
import moment from 'moment-timezone';
import TenantService from 'api/tenant.service';
import AssetsService from 'api/assets.service';
import FloorplanPopupMultiple from 'pages/components/floorplanMultiple';
import '../../../asset.css'
import Toast from 'components/Toast';
import DataSource from 'devextreme/data/data_source';
import hash from 'hash.js';
import { useLocation } from 'react-router-dom';



const AnalyzeSpaceTab = (props) => {
    const location = useLocation();
    const idsData = location.state?.data;
    //   const assetName = props.assetName
    const [data, setData] = useState([])
    const [spaces, setSpaces] = useState([])
    const [tags, setTags] = useState([])
    const [selectedSpace2, setSelectedSpace2] = useState()
    const [showMyFloorplan, setShowMyFloorplan] = useState(true)
    const [showMyFloorplan2, setShowMyFloorplan2] = useState(true)
    const tenant = TenantService.getTenant()
    const [lines, setLines] = useState(true)
    const dropDataGridRef = useRef();
    const [selectedValue, setSelectedValue] = useState('Last 24 hours');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const dateBoxRefStart = useRef(null);
    const dateBoxRefEnd = useRef(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loadingText, setLoadingText] = useState('Loading...');
    const [focusedRowKey, setFocusedRowKey] = useState(null);
    const [predefinedColors, setPredefinedColors] = useState([]);
    const [hoveredCoordinates, setHoveredCoordinates] = useState(null);
    const [isDisableAutoUpdate, setIsDisableAutoUpdate] = useState(false)
    const [checkAutoUpdate, setCheckAutoUpdate] = useState(true);
    const WAIT_TIME = 10000;
    const intervalRef = useRef(null);
    const isUserInteracting = useRef(false); // Track user interaction
    const [multipleAssetData, setMultipleAssetData] = useState([])


    const clearDataSource = () => {
        // Set the data to an empty array
        dataSource.store().clear(); // Clears all data in the store
        dataSource.reload(); // Refresh the DataSource to reflect the changes
    };

    const dataSource = useMemo(() => new DataSource({
        store: {
            type: 'array',
            key: 'id',
            data: [],
        },
    }), []);


    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 15000,
    });

    useEffect(() => {
        // Fetch asset data (assuming JSON file in public folder)
        fetch("/colors.json")
            .then(response => response.json())
            .then(data => {

                setPredefinedColors(getColorsForAssets(data.length, [])); // Provide an empty array for now
            })
            .catch(error => console.error("Error loading JSON", error));
    }, []);

    function generateDeterministicId(record) {
        return hash.sha256().update(`${record.asset}-${record.time}-${record.motion}`).digest('hex');
    }

    const assetColorMap = new Map();

    function indexToRGB(index) {
        let r = (index >> 6) & 0b111; // Extract red (3 bits)
        let g = (index >> 3) & 0b111; // Extract green (3 bits)
        let b = index & 0b111;        // Extract blue (3 bits)

        // Normalize to [0, 1] range
        return { normalized: [r / 7, g / 7, b / 7], raw: [r, g, b] };
    }

    function colorDistance(c1, c2) {
        return Math.sqrt(
            (c1[0] - c2[0]) ** 2 +
            (c1[1] - c2[1]) ** 2 +
            (c1[2] - c2[2]) ** 2
        );
    }

    function generateMaximallySeparatedColors() {
        let allColors = Array.from({ length: 512 }, (_, i) => {
            let { normalized, raw } = indexToRGB(i);
            return { index: i, normalized, raw };
        });

        let chosenColors = [allColors[0]];
        let remainingColors = allColors.slice(1);

        while (chosenColors.length < 512) {
            let maxMinDist = -1;
            let nextColor = null;

            for (let candidate of remainingColors) {
                let minDist = Math.min(
                    ...chosenColors.map(chosen => colorDistance(candidate.normalized, chosen.normalized))
                );

                if (minDist > maxMinDist) {
                    maxMinDist = minDist;
                    nextColor = candidate;
                }
            }

            chosenColors.push(nextColor);
            remainingColors = remainingColors.filter(c => c.index !== nextColor.index);
        }

        return chosenColors.map(color => color.raw);
    }

    function getColorsForAssets(assetCount, predefinedColors) {
        let predefinedColorsArray = predefinedColors || [];

        if (assetCount > predefinedColorsArray.length) {
            return generateMaximallySeparatedColors().slice(0, assetCount);
        } else {
            return predefinedColorsArray.slice(0, assetCount);
        }
    }

    function generateColor(index, predefinedColors) {
        let predefinedColor = getColorsForAssets(index + 1, predefinedColors);
        return predefinedColor[index] || [0, 0, 0];
    }

    function appendAssetsData(newRecords) {
        console.log('NEW RECORS: ', newRecords);

        newRecords.forEach((record) => {
            record.id = generateDeterministicId(record); // Replace uuid with a deterministic id
        });
        console.log('NEW RECORDS2: ', newRecords);

        const store = dataSource.store();

        newRecords.forEach((record) => {
            store.byKey(record.id)
                .then(() => {
                    console.log('Duplicate record found, skipping:', record);
                })
                .catch(() => {
                    // Only insert if the key doesn't exist
                    try {
                        store.insert(record);
                    } catch (error) {
                        console.log('Error inserting record:', record, error);
                    }
                });
        });

        dataSource.reload();
        const areArraysEqual = (arr1, arr2) => {
            if (arr1.length !== arr2.length) return false;
            return arr1.every((item, index) =>
                item.id === arr2[index].id &&
                item.asset === arr2[index].asset &&
                item.serialNumber === arr2[index].serialNumber &&
                item.spaceCoordinates.x === arr2[index].spaceCoordinates.x &&
                item.spaceCoordinates.y === arr2[index].spaceCoordinates.y
            );
        };

        let markers = [];
        if (newRecords && newRecords.length > 0) {
            console.log('no loading text');
            // setLoadingText("Loading...");
            for (let i = 0; i < newRecords.length; i++) {
                if (newRecords[i].isFloorplan && newRecords[i].space.localCoordinates !== null) {
                    markers.push({
                        parentId: newRecords[i].id,
                        id: newRecords[i].space.id,
                        asset: newRecords[i].asset,
                        serialNumber: moment(newRecords[i].time).format("YYYY-MM-DD HH:mm:ss"),
                        spaceCoordinates: {
                            x: newRecords[i].space.localCoordinates.x,
                            y: newRecords[i].space.localCoordinates.y
                        },
                        assetType: newRecords[i].assetType ? newRecords[i].assetType : null,
                        maintenanceStatus: newRecords[i].maintenanceStatus ? newRecords[i].maintenanceStatus : null
                    });
                }
            }

            const sortedArray = markers.sort((a, b) => new Date(a.serialNumber) - new Date(b.serialNumber));

            // Compare sortedArray with current tags
            if (!areArraysEqual(sortedArray, tags)) {
                console.warn('UPdating tags');
                
                sortedArray.forEach((item) => {
                    if (!assetColorMap.has(item.asset)) {
                        let color;
                        if (predefinedColors.length > assetColorMap.size) {
                            color = predefinedColors[assetColorMap.size]; // Assign next available predefined color
                        } else {
                            color = generateColor(assetColorMap.size, predefinedColors); // Generate new color if needed
                        }
                        assetColorMap.set(item.asset, color);
                    }
                });

                const updatedOrgArr = sortedArray.map((item) => ({
                    ...item,
                    color: assetColorMap.get(item.asset), // Use stored color
                }));
                console.log('updatedOrgArr: ', updatedOrgArr);

                const updatedOrgArrWithRGB = updatedOrgArr.map(item => {
                    let color = item.color;
                    if (Array.isArray(color) && color.length === 3) {
                        color = `rgb(${color[0] * 36}, ${color[1] * 36}, ${color[2] * 36})`;
                    }
                    return { ...item, color };
                });

                setTags(updatedOrgArrWithRGB); // Update state only if there are changes
            } else {
                console.log("No new data, skipping update.");
            }
        } else {
            console.log('no loading text 211');
            setLoadingText("No Data");
            clearDataSource();
            setTags([]);
        }
    }

    useEffect(() => {
        // Retrieve data from localStorage
        // const storedData = localStorage.getItem(`multiple-asset-selection-ids-${tenant}`);

        if (idsData) {
            setMultipleAssetData(idsData);
        }
        getData()
    }, []);

    async function getSpaces() {
        const from = moment(localStorage.getItem(`${tenant}dateFilterFrom`)).utc().format();
        const to = moment(localStorage.getItem(`${tenant}dateFilterTo`)).utc().format();

        if (from === "Invalid date" || to === "Invalid date") {
            setLoadingText("No Data");
            return;
        } else {
            setLoadingText("Loading...");
        }

        try {
            const storedAssetData = localStorage.getItem(`multiple-asset-selection-ids-${tenant}`);
            const parsedAssetData = storedAssetData ? JSON.parse(storedAssetData) : [];
            const finalAssetData = multipleAssetData?.length > 0 ? multipleAssetData : parsedAssetData;
            const value = await AssetsService.locationHistoryMultiple(finalAssetData, from, to, null, "asset");
            const floorplans = value?.data?.data?.floorplans || [];
            setSpaces(floorplans);
            props.onSpaceLoad(floorplans);

            if (floorplans.length > 0) {
                const firstSpaceId = floorplans[0]?.id;
                setSelectedSpace2(firstSpaceId);
                setShowMyFloorplan(true);
                setShowMyFloorplan2(true);
                getData(firstSpaceId);
            } else {
                console.log('No floorplan found');
                setShowMyFloorplan(false);
                setShowMyFloorplan2(false);
                setLoadingText("No Data");
            }

        } catch (error) {
            console.error('Error fetching asset location history:', error);
            setShowMyFloorplan(false);
            setShowMyFloorplan2(false);
            setLoadingText("Failed to load data");
        }
    }

    function getData(space) {
        if (space === undefined || space === null) return;
        const from = moment(localStorage.getItem(`${tenant}dateFilterFrom`)).utc().format();
        const to = moment(localStorage.getItem(`${tenant}dateFilterTo`)).utc().format();
        if (from !== null && to !== null) {
            const storedAssetData = localStorage.getItem(`multiple-asset-selection-ids-${tenant}`);

            // Parse `localStorage` data safely (if available), else fallback to []
            const parsedAssetData = storedAssetData ? JSON.parse(storedAssetData) : [];

            // Use `multipleAssetData` if it has data, otherwise pick from `localStorage`
            const finalAssetData = multipleAssetData && multipleAssetData.length > 0 ? multipleAssetData : parsedAssetData;
            AssetsService.locationHistoryMultiple(finalAssetData, from, to, space, "asset").then((value) => {
                if (value.data.data.floorplans.length !== 0) {
                    setShowMyFloorplan(true)
                    setShowMyFloorplan2(true)
                } else {
                    setShowMyFloorplan(false)
                    setShowMyFloorplan2(false)
                }
                if (value.data && value.data.data && value.data.data.history.length > 0) {
                    console.log('327')
                    setLoadingText('Loading...')
                    appendAssetsData(value.data.data.history);
                } else {
                    setLoadingText('No Data')
                }
                if (value?.data?.data?.message) {
                    setToastConfig({
                        ...toastConfig,
                        isVisible: true,
                        type: value?.status === 200 ? 'success-warning' : 'error',
                        status: value?.data?.status ? 320 : value.status,
                        message: value?.data?.data?.message ? value?.data.data.message : value.message,
                    });
                }
            })
        }
    }

    const onTaskIdChanged = useCallback((val) => {
        setFocusedRowKey(val);
    }, []);

    const highlightRow = (rowIndex) => {
        const dataGridInstance = dropDataGridRef.current.instance().option('dataSource');
        const dataLength = dataGridInstance.length
        const rowId = dataGridInstance[dataLength - 1 - rowIndex].id
        const rowIndexFound = dataGridInstance.findIndex(obj => obj.id === rowId);
        dropDataGridRef.current.instance().selectRows([rowId]);
        if (rowIndexFound !== -1) {
            onTaskIdChanged(dataGridInstance[rowIndexFound].id)
        }
    }

    function showFloorplan() {
        if (selectedSpace2 !== undefined && tags !== undefined) {
            return (
                <FloorplanPopupMultiple hoveredCoordinates={hoveredCoordinates} spaceId={selectedSpace2} myMarkers={tags} type={lines ? 'polyline' : 'polyline2'} zoneEditControl={false} highlightRow={highlightRow}>
                </FloorplanPopupMultiple>
            )
        }
    }

    useEffect(() => {
        // Fetch data when the component mounts
        setTimeout(() => {
            getSpaces();
        }, 2000);

    }, []);

    return (
        <>
            <Toast
                setParentToastConfig={setToastConfig}
                toastBody={toastConfig}
            />
            <div className='assetContainer'>
                <div className={(showMyFloorplan && showMyFloorplan2) ? 'showFloorplan' : 'hideFloorplan'}>
                    {showFloorplan()}
                </div>
            </div>
        </>
    )
}

export default AnalyzeSpaceTab;